// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/2290994c02ec6c675d33.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"a1608d2e39d56a4f27fa","167":"58c2cd394666864b8c46","168":"55822f98845e3a7c741b"}[chunkId] + ".chunk.js";
};